var React = require('react');

function NpDashTopTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 2C2 560 938 448 1108 175","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"4 10"}));
}

NpDashTopTop.defaultProps = {"width":"1110","height":"403","viewBox":"0 0 1110 403"};

module.exports = NpDashTopTop;

NpDashTopTop.default = NpDashTopTop;
